import { create } from "zustand";

export const useConfirm = create((set) => ({
  show: false,
  title: "",
  content: "",
  type: "error",
  onConfirm: null,
  confirmText: "Xác nhận",
  onCancel: null,
  cancelText: "Hủy",
  confirm: ({
    title,
    content,
    type,
    onConfirm,
    confirmText,
    onCancel,
    cancelText,
  }) =>
    set({
      show: true,
      title,
      content,
      type,
      onConfirm,
      confirmText,
      onCancel,
      cancelText,
    }),
  close: () => set({ show: false }),
}));
